import script from "./PhaseFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhaseFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./PhaseFormModal.vue?vue&type=style&index=0&id=5af2ba18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af2ba18"]])

export default __exports__